enum ActionState {
    None,
    Executing,
    Succeed,
    FailureNotice,
    FailureRetry,
}

export default ActionState;
